import { render, staticRenderFns } from "./linkedbutton.vue?vue&type=template&id=f6efc1cc&scoped=true"
import script from "./linkedbutton.vue?vue&type=script&lang=js"
export * from "./linkedbutton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6efc1cc",
  null
  
)

export default component.exports